import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { AppInfoPopup } from '../app-info/app-info-popup.component';
import { BaseComponent } from '../shared/base.component';
import { UserAccountPopup } from '../user-account/user-account-popup.component';
import { UnknownUser } from '../user/unknown-user.model';


@Component({
    selector: 'app-site-header',
    standalone: true,
    imports: [
        MatTabsModule,
        MatMenuModule,
        MatButtonModule
    ],
    templateUrl: './site-header.component.html',
    styleUrl: './site-header.component.css'
})
export class SiteHeaderComponent extends BaseComponent {

    private matDialog: MatDialog = inject(MatDialog);

    public openUserAcctPopup(): void {
        const dialogRef = this.matDialog.open(UserAccountPopup, {
            disableClose: true
        });
    }

    public openAppInfoPopup(): void {
        const dialogRef = this.matDialog.open(AppInfoPopup, {
            disableClose: false
        });
    }

    protected get isUnknownUser(): boolean {
        return this.stateManager.getUserAccount() instanceof UnknownUser;
    }
}
